import {useState} from "../../__snowpack__/pkg/react.js";
import {createModel} from "../../__snowpack__/pkg/hox.js";
import {axios} from "../lib/axios.js";
import {handleError} from "../lib/errorHandler.js";
export const useCurrentPackage = () => {
  const [CurrentList, setCurrentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const {data} = await axios.get("/saas/merchant-plan/list-valid");
      setCurrentList(data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    currentLoading: loading,
    packageList: CurrentList,
    fetchCurrentListValid: fetchData
  };
};
export const useCurrentPackageModel = createModel(useCurrentPackage);
